import { AlignLeftIcon } from "@phosphor-icons/react/dist/ssr/AlignLeft";
import { CalendarCheckIcon } from "@phosphor-icons/react/dist/ssr/CalendarCheck";
import { ChartLineUpIcon } from "@phosphor-icons/react/dist/ssr/ChartLineUp";
import { GlobeHemisphereWestIcon } from "@phosphor-icons/react/dist/ssr/GlobeHemisphereWest";
import { KanbanIcon } from "@phosphor-icons/react/dist/ssr/Kanban";
import { ReadCvLogoIcon } from "@phosphor-icons/react/dist/ssr/ReadCvLogo";
import { UsersIcon } from "@phosphor-icons/react/dist/ssr/Users";

export const icons = {
	"align-left": AlignLeftIcon,
	"calendar-check": CalendarCheckIcon,
	"chart-line-up": ChartLineUpIcon,
	"globe-hemisphere-west": GlobeHemisphereWestIcon,
	"read-cv-logo": ReadCvLogoIcon,
	kanban: KanbanIcon,
	users: UsersIcon,
};
